import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listMyQuotations } from '../api/vendorApi';
import { VpSpinner, VpEmpty, VpStatusBadge, money, fmtDate } from '../components/VpUI';

const VendorMyQuotations = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [rows, setRows] = useState<any[]>([]);
	const [error, setError] = useState('');

	useEffect(() => {
		(async () => {
			try {
				const data = await listMyQuotations();
				setRows(Array.isArray(data) ? data : []);
			} catch (err: any) {
				setError(err?.apiMessage || 'Could not load your quotations.');
			} finally {
				setLoading(false);
			}
		})();
	}, []);

	if (loading) return <VpSpinner />;
	if (error) return <div className='vp-alert vp-alert-error'>{error}</div>;

	return (
		<div className='vp-card'>
			<div className='vp-card-head'>
				<h3>My Quotations</h3>
			</div>
			{rows.length === 0 ? (
				<VpEmpty icon='📝' text='You have not submitted any quotations yet.' />
			) : (
				<div className='vp-table-wrap'>
					<table className='vp-table'>
						<thead>
							<tr>
								<th>Quotation No</th>
								<th>Requisition</th>
								<th>Date</th>
								<th style={{ textAlign: 'right' }}>Amount</th>
								<th>Status</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((q) => (
								<tr
									key={q._id}
									style={{ cursor: 'pointer' }}
									onClick={() => navigate(`/vendor-portal/quotations/${q._id}`)}>
									<td style={{ fontWeight: 600 }}>{q.quotation_no}</td>
									<td>{q.requisition?.requisition_no || '—'}</td>
									<td>{fmtDate(q.quotation_date || q.createdAt)}</td>
									<td style={{ textAlign: 'right' }}>{money(q.amount_total)}</td>
									<td>
										<VpStatusBadge status={q.quotation_status} />
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};

export default VendorMyQuotations;
